import React, {Component, createRef} from 'react';


const options = {
    height: 900,
    width: '100%',
    toolbarPosition: 'top',
    // hideTabs: true,
    // All other vizCreate options are supported here, too
    // They are listed here: 
    // https://onlinehelp.tableau.com/current/api/js_api/en-us/JavaScriptAPI/js_api_ref.htm#ref_head_9
};

// const filters = {
//     Colors: ['Blue', 'Red'],
//     Sizes: ['Small', 'Medium']
// };

// const parameters = {
//     Param1: 'Value',
//     Param2: 'Other Value'
// };

const {tableau} = window;


export default class TableauView extends Component {

    tableauRef = createRef();

    componentDidMount = () => {
        this.initViz();
    };

    initViz = () => {
        const url = "https://prod-apnortheast-a.online.tableau.com/t/openminds/views/Superstore/Overview/niraj.choudhary@mindfiresolutions.com/971d002a-e26d-4fe0-9656-0aa80da337eb";
        const url1 = "https://prod-useast-a.online.tableau.com/t/agencyperformancepartners/views/CrossInsuranceActivityDashboard/CancellationReport"
        const url2 = "https://prod-apnortheast-a.online.tableau.com/t/openminds/views/CrossInsuranceActivityDashboard1/CancellationReport"
        // tableau = window.tableau;
        // console.log(tableau)
        if (tableau && this.tableauRef && this.tableauRef.current) {
            new tableau.Viz(this.tableauRef.current, url2, options);
        }
    }

    render = () => {
        return (
            <div className="my-3 bg-white" ref={this.tableauRef}></div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/tableau/Views.js